import React from 'react';
import { Images } from '../../app-constants';
import ImageIcon from './image-icon';

const BrokenLink = () => (
  <ImageIcon src={Images.BrokenLink} alt="broken-link" />
);

export default BrokenLink;
